module.exports = __webpack_public_path__ + "media/images/undraw_empty_street-0d92b6a646ce87e50ea41e1941693b85.svg";